import AttachFileIcon from '@mui/icons-material/AttachFile';
import EmailIcon from '@mui/icons-material/Email';
import ForumIcon from '@mui/icons-material/Forum';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PublicIcon from '@mui/icons-material/Public';
import SmsIcon from '@mui/icons-material/Sms';
import VerifiedIcon from '@mui/icons-material/Verified';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import {
    Avatar,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    TextField
} from "@mui/material";
import { useCallback, useEffect, useState } from 'react';
import { FaSearch, FaStar } from 'react-icons/fa';
import { MdOutlinePhoneIphone } from "react-icons/md";
import { ReactComponent as GroupChatFilled } from '../../../../Assets/img/icons/group-chat-figma.svg';
import { ReactComponent as PaymentFilled } from '../../../../Assets/img/icons/payment-icon-figma.svg';
import { ReactComponent as VideoCallFilled } from '../../../../Assets/img/icons/video-call-figma.svg';
import { ReactComponent as VideoTutorialFilled } from '../../../../Assets/img/icons/video-tutorial-figma.svg';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import { useQuantityContext } from '../../../QuantityContext';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { IconButton, Tooltip } from '@mui/material';
import "cropperjs/dist/cropper.css";
import CryptoJS from 'crypto-js';
import _ from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as FavouriteStar } from "../../../../Assets/img/icons/Favourites star icon.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import useApi from '../../../Utilities/useAPI';
import SpeedDialComponent from './SpeedDialComponent';

function CardConnectedMembers() {
    const { isEnabledCCE, ContactView } = useQuantityContext();
    const group = []; // Replace with actual data fetching logic
    const dispatch = useDispatch();
    const { cardName } = useParams();
    // console.log("cardName", cardName)
    // const { CardConnectMember } = useContext(ContactsDetContext);
    const Folders = useSelector((state) => state?.ContactArray?.UserFolderDetails?.data);
    // console.log("Folder data ", Folders)
    // console.log("PArticular FolderDAta", CardConnectMember);
    const navigate = useNavigate();

    // const [filteredMembers, setFilteredMembers] = useState(CardConnectMember[cardName]);
    const formatGroupsData = (data) => {

        const groupNames = data && typeof data === 'object' ? Object.keys(data) : [];


        // Initialize an empty object to store the formatted data
        const formattedGroups = {};

        groupNames.forEach((groupName) => {
            const members = data[groupName];
            // console.log("Conte ni the context", members);
            if (members?.length > 0) {
                formattedGroups[groupName] = members.map((member) => ({
                    img: member.card_details?.profile_url || "",
                    name: `${member.first_name} ${member.last_name}`,
                    contact_ref_id: member?.reference_id,
                    role: "FRIEND",
                    email: member.card_details?.card_email,
                    phone_no: member?.card_details?.card_mobile?.replace(/[\s-]/g, ''),
                    verified: true,
                    isfavourite: false
                }));
            }
            // console.log("Member data", members);
        });

        return formattedGroups;
    };

    const CardConnectMember = formatGroupsData(Folders);
    // console.log(" CARD CONNECTED DATA", CardConnectMember);


    const [filteredMembers, setFilteredMembers] = useState(CardConnectMember[cardName]);

    const [groupMembers, setGroupMembers] = useState(CardConnectMember[cardName]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDetails, setShowDetails] = useState(isEnabledCCE);
    const [isListView, setIsListView] = useState(ContactView === "List View"); // State to toggle list view
    const [expandedItem, setExpandedItem] = useState(null); // State to track expanded item
    const [openOverflowIndex, setOpenOverflowIndex] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});  // Initialize with an empty object for item selection
    const [selectAll, setSelectAll] = useState(false);        // State for "Select All" checkbox
    const [deleteConfirm, setdeleteConfirm] = useState(false);
    const [muteContact, setMuteContact] = useState(false);
    const [selectAllContacts, setSelectAllContacts] = useState(false);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const { callApiFunction } = useApi();

    const cceFunctions = [
        { icon: VideoCallFilled, function: undefined },
        { icon: WhatsappFilled, function: undefined },
        { icon: ForumIcon, function: undefined },
        { icon: GroupChatFilled, function: undefined },
        { icon: AttachFileIcon, function: undefined },
        { icon: VideoTutorialFilled, function: undefined },
        { icon: VolumeUpRoundedIcon, function: undefined },
        { icon: EmailIcon, function: undefined },
    ];

    // Handle "Select All" logic
    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedItems("")
            // selectAllContacts(false);
        }
        setSelectAll(!selectAll);
    };

    const handleSelectedcontacts = () => {
        if (!selectAllContacts) {
            // Select all members
            const newSelectedMembers = {};
            filteredMembers.forEach((member) => {
                newSelectedMembers[member.contact_ref_id] = true; // Set each member's ID to true
            });
            setSelectedItems(newSelectedMembers); // Update state with selected items
            setSelectAllContacts(true); // Set 'Select All' to true
        } else {
            // Deselect all members
            setSelectedItems({}); // Clear all selected items
            setSelectAllContacts(false); // Set 'Select All' to false
        }
    };

    const [showOptionsBar, setShowOptionsBar] = useState(false)
    // Handle individual item selection
    const handleItemSelection = (contact_ref_id) => {
        const newSelectedItems = { ...selectedItems, [contact_ref_id]: !selectedItems[contact_ref_id] };
        setSelectedItems(newSelectedItems);

        const hasSelectedItems = Object.values(newSelectedItems).some(isSelected => isSelected);
        setShowOptionsBar(hasSelectedItems);
    };

    useEffect(() => {
        setShowDetails(isEnabledCCE);
    }, [isEnabledCCE]);

    useEffect(() => {
        setIsListView(ContactView === "List View");
    }, [ContactView]);




    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //         setDebouncedSearchTerm(searchTerm);
    //     }, 300); // Adjust debounce delay as needed

    //     return () => clearTimeout(handler);
    // }, [searchTerm]);

    // useEffect(() => {
    //     if (debouncedSearchTerm.trim() && groupMembers) {
    //         setFilteredMembers(
    //             groupMembers.filter(member =>
    //                 `${member?.first_name} ${member?.last_name}`.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) ||
    //                 member?.card_details?.card_type?.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
    //             )
    //         );
    //     } else {
    //         setFilteredMembers(debouncedSearchTerm.trim() === "" ? groupMembers : []);
    //     }
    // }, [debouncedSearchTerm, groupMembers]);


    const handleSearchChange = useCallback(
        _.debounce((value) => {
            if (value.trim()) {
                setFilteredMembers(
                    groupMembers.filter(member =>
                        `${member?.name} `
                            .toLowerCase()
                            .includes(value.toLowerCase()) ||
                        member?.card_details?.card_type
                            .toLowerCase()
                            .includes(value.toLowerCase())
                    )

                );
                // console.log("INSIDE THE Search", filteredMembers)
            } else {
                setFilteredMembers(groupMembers); // Reset when input is empty
            }
        }, 300), // Debounce delay (adjust as needed)
        [groupMembers]
    );

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        handleSearchChange(value); // Calls debounced function
    };

    // useEffect(() => {
    //     dispatch(getUserFolderDetailsReducer());
    // }, [])



    function generateRandomDate() {
        const start = new Date(2020, 0, 1); // Start date (1st January 2020)
        const end = new Date(); // Current date
        const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

        // Format the date as 'Apr 21, 2024'
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return randomDate.toLocaleDateString('en-US', options);
    }

    const toggleOverflow = (index) => {
        setOpenOverflowIndex((prev) => {
            const newState = [...prev];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const toggleExpand = (index) => {
        if (expandedItem === index) {
            setExpandedItem(null); // Collapse if already expanded
        } else {
            setExpandedItem(index); // Expand the clicked item
        }
    };

    const handleDelete = async () => {
        const contact_ref_ids = Object.keys(selectedItems)
            ?.filter(id => selectedItems[id])
            ?.map(id => parseInt(id, 10)); // Ensure IDs are integers

        // Update selectedGroupMembers and filteredMembers by removing deleted contacts
        setGroupMembers((prevMembers) => {
            const updatedMembers = prevMembers?.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        setFilteredMembers((prevMembers) => {
            const updatedMembers = prevMembers?.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        // Optionally, clear the selected items if needed
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = { ...prevSelectedItems };
            contact_ref_ids.forEach(id => {
                delete updatedSelectedItems[id];
            });
            return updatedSelectedItems;
        });

        setdeleteConfirm(false);
        try {
            const response = await callApiFunction('deleteContacts', {
                contact_ref_ids: contact_ref_ids,
            });
            // console.log("Deleted Successfully", response);
        } catch (error) {
            console.log('Error uploading file:', error.message);
        }

    }



    const selectedContacts = Object.keys(selectedItems)?.filter(key => selectedItems[key]);

    const toggleFavoriteStatus = async (contact_ref_id, currentStatus) => {
        try {
            // Update favorite status locally after the API call succeeds
            setGroupMembers((prevMembers) =>
                prevMembers?.map((member) =>
                    member.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            setFilteredMembers((prevMembers) =>
                prevMembers?.map((member) =>
                    member?.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            const response = await callApiFunction('favouriteContact', {
                is_favourite: !currentStatus,
                contact_ref_id: contact_ref_id
            });
            // console.log("Favourite Card Updated", response.message);
        } catch (err) {
            console.log('Error updating favorite status:', err);
        }
    };

    const handleNavigate = (id) => {

        const encryptedId = CryptoJS.AES.encrypt(id?.toString(), 'UserDetailsSecretKey').toString();
        // navigate(`/userDetailedInfo/${encodeURIComponent(encryptedId)}`);
        navigate(`/userDetailedInfo?encryptedId=${encodeURIComponent(encryptedId)}`);
        // navigate(`/userDetailedInfo/${id}`)
    }

    // useEffect(() => {
    //     console.log("Filtered members updated:", filteredMembers);
    // }, [filteredMembers]);


    return (
        <div className="outer-layer-of-contacts">
            <div className="outer-container">
                <div className="displayflex justify-content-between align-items-center">
                    <h6 className="fw-bold">All Contacts</h6>
                    <div className="flex-center">
                        {!isListView &&
                            <div className="">
                                {selectAll && <FormControlLabel
                                    control={<Checkbox checked={selectAllContacts} onChange={handleSelectedcontacts} />}
                                    label="Select All"
                                />}
                                <FormControlLabel
                                    className='customized_formControl'
                                    control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} />}
                                    label="Select"
                                />
                            </div>}
                        <div style={{ marginRight: '10px' }}>
                            {/* <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleInputChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            /> */}

                            <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleInputChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            />
                        </div>
                    </div>
                </div>

                {!isListView ? (
                    <div className="avatars-container">
                        {filteredMembers?.map((member, index) => (
                            <div key={index} className={`avatar-box-outer ${!showDetails ? 'compact' : ''}`}>
                                <div className={`avatar-box t ${!showDetails ? 'compact' : ''}`}>
                                    <div className="flex-center avatar-details-wrapper pointer" onClick={() => { handleNavigate(member.contact_ref_id) }}>

                                        {selectAll ? (
                                            <div className="dot_status_contacts">
                                                <Checkbox
                                                    checked={selectedItems[member.contact_ref_id] || false}
                                                    onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                    onChange={(e) => {
                                                        e.stopPropagation(); // Stop event from bubbling up
                                                        handleItemSelection(member.contact_ref_id);
                                                    }}
                                                    className="member-checkbox p-0"
                                                />
                                            </div>
                                        ) : (
                                            <div className="dot_status_contacts"
                                                style={{ backgroundColor: member.verified ? "#43A047" : "#EB4E3D" }}></div>
                                        )}

                                        <div className='star_fav_cards' onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)
                                        }}>
                                            {member.is_favourite ? (
                                                <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} />
                                            ) : (
                                                <FavouriteStar />
                                            )}
                                        </div>
                                        <div className="avatar-details t">
                                            <div>
                                                <div className="avatar-image t">
                                                    {/* <img className='cover-image' src={member.img} alt={member.name} /> */}
                                                    <Avatar
                                                        className="w-100 h-100 cover-image" style={{ fontSize: "3rem" }}
                                                        alt={member.name}
                                                        src={member.img || undefined}
                                                    >{member?.name?.charAt(0).toUpperCase()}</Avatar>
                                                </div>
                                                <div className={`symbol_of_contacts ${!showDetails ? 'compact' : ''}`}>
                                                    {member.verified ?
                                                        <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                        <NonVerifiedTickNew />
                                                    }
                                                </div>
                                            </div>
                                            {/* {showDetails && <div className="vertical-line"></div>} */}
                                            <div className="member-info word-break">
                                                <Tooltip title={member.name} placement="bottom">
                                                    <div className="member-name">
                                                        {member?.name?.length > 10
                                                            ? `${member.name.slice(0, 10)}...`
                                                            : member.name}
                                                    </div>
                                                </Tooltip>
                                                <div className="member-role">{member.role}</div>
                                                {showDetails && <div className="member-email truncate">{member.email}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    {/* {console.log("Mani Check is", filteredMembers)} */}


                                    {showDetails && (
                                        <>
                                            <div className="icons-container">
                                                <a href={`tel:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><MdOutlinePhoneIphone className="icon" /></div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><SmsIcon className="icon" /></div>
                                                </a>
                                                <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><EmailIcon className="icon" /></div>
                                                </a>
                                                <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><WhatsappFilled className="icon figma-icon" /></div>
                                                </a>
                                                <div className="icon-box"><MoreHorizIcon className="icon" onClick={() => toggleOverflow(index)} /></div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                {showDetails && openOverflowIndex[index] && (
                                    <>
                                        <div className="overflow-menu icons-container ms-2">
                                            <div className="icon-box"><AttachFileIcon className="icon" /></div>
                                            <div className="icon-box"><PublicIcon className="icon" /></div>
                                            <div className="icon-box"><VideoCallFilled className="icon figma-icon" /></div>
                                            <div className="icon-box"><VolumeUpRoundedIcon className="icon" /></div>
                                            <div className="icon-box"><PaymentFilled className="icon figma-icon" /></div>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="list-container">
                        <ul className="members">
                            {/* Column headers */}
                            <div className="header-row">
                                <div className="header-column select-all me-3">
                                    <FormControlLabel
                                        className='customized_formControl ms-3'
                                        control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} className='ps-0' />}
                                        label="Select All"
                                    />
                                </div>
                                <div className="header-column name-email-details-column">
                                    Name and Email
                                </div>
                                <div className="header-column name-email-details-column">
                                    Details
                                </div>
                                <div className="header-column date">
                                    Date
                                </div>
                                <div className="header-column actions">
                                    Actions
                                </div>
                            </div>

                            {/* {filteredMembers?.map((member, index) => (
                                <div key={index} className={`list-item-container ${expandedItem === index ? 'expanded' : ''}`}>
                                    <li key={index} className={`list-item ${expandedItem === index ? 'expanded' : ''}`} onClick={() => { handleNavigate(member.contact_ref_id) }}>
                                        <div className='d-flex align-items-center header-column select-all ms-3' style={{ position: "relative" }}>
                                            <Checkbox onClick={(e) => e.stopPropagation()}
                                                checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                className="member-checkbox p-0"
                                            />
                                            <div className="list-avatar" style={{ position: "absolute", right: "10%" }}>
                                                <div className='w-100 h-100' style={{ position: "relative" }}>
                                                    <Avatar style={{ fontSize: "2rem" }}
                                                        className="w-100 h-100 cover-image"
                                                        alt={member.name}
                                                        src={member.img || undefined}
                                                    >{member?.name?.charAt(0).toUpperCase()}</Avatar>

                                                    <div className={`symbol_of_contacts2_list`}>
                                                        {member.verified ?
                                                            <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                            <NonVerifiedTickNew />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="name-email-details header-column name-email-details-column">
                                            <span className="list-name">{member.name}</span>
                                            <span className="list-email">{member.email}</span>
                                        </div>
                                        <span className="list-role header-column name-email-details-column">{member.role}</span>
                                        <span className="list-date header-column date">{generateRandomDate()}</span>
                                        <span className="list-actions header-column actions align-items-center icon-20px" onClick={(e) => e.stopPropagation()}>

                                            {member.is_favourite ? (
                                                <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} onClick={() => toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)} />
                                            ) : (
                                                <FavouriteStar onClick={() => toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)} />
                                            )}
                                            <MoreVertIcon className={`ms-2 ${expandedItem === index ? 'color-blue' : 'icon-color'}`} onClick={() => toggleExpand(index)} />
                                        </span>

                                        {expandedItem === index && (
                                            <div className="group-options-bar additional-info">
                                                <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer'>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()} >
                                                        <EmailIcon className="pointer" />
                                                    </div>
                                                </a>
                                                <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <WhatsappFilled className="pointer figma-icon" />
                                                    </div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <GroupChatFilled className="pointer figma-icon" />
                                                    </div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <ForumIcon className="pointer" />
                                                    </div>
                                                </a>

                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VolumeUpRoundedIcon className="pointer" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VideoTutorialFilled className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <AttachFileIcon className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VideoCallFilled className="pointer figma-icon" />
                                                </div>
                                            </div>
                                        )}
                                    </li>
                                </div>
                            ))} */}

                            {filteredMembers?.map((member, index) => {
                                // console.log("MEMBERSSS", member); // Log the member object
                                return (
                                    <div key={index} className={`list-item-container ${expandedItem === index ? 'expanded' : ''}`}>
                                        <li key={index} className={`list-item ${expandedItem === index ? 'expanded' : ''}`} onClick={() => { handleNavigate(member.contact_ref_id) }}>
                                            <div className='d-flex align-items-center header-column select-all ms-3' style={{ position: "relative" }}>
                                                <Checkbox onClick={(e) => e.stopPropagation()}
                                                    checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                    onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                    className="member-checkbox p-0"
                                                />
                                                <div className="list-avatar" style={{ position: "absolute", right: "10%" }}>
                                                    <div className='w-100 h-100' style={{ position: "relative" }}>
                                                        <Avatar style={{ fontSize: "2rem" }}
                                                            className="w-100 h-100 cover-image"
                                                            alt={member.name}
                                                            src={member.img || undefined}
                                                        >{member?.name?.charAt(0).toUpperCase()}</Avatar>

                                                        <div className={`symbol_of_contacts2_list`}>
                                                            {member.verified ?
                                                                <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                                <NonVerifiedTickNew />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="name-email-details header-column name-email-details-column">
                                                <span className="list-name">{member.name}</span>
                                                <span className="list-email">{member.email}</span>
                                            </div>
                                            <span className="list-role header-column name-email-details-column">{member.role}</span>
                                            <span className="list-date header-column date">{generateRandomDate()}</span>
                                            <span className="list-actions header-column actions align-items-center icon-20px" onClick={(e) => e.stopPropagation()}>
                                                {member.is_favourite ? (
                                                    <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} onClick={() => toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)} />
                                                ) : (
                                                    <FavouriteStar onClick={() => toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)} />
                                                )}
                                                <MoreVertIcon className={`ms-2 ${expandedItem === index ? 'color-blue' : 'icon-color'}`} onClick={() => toggleExpand(index)} />
                                            </span>

                                            {expandedItem === index && (
                                                <div className="group-options-bar additional-info">
                                                    <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer'>
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()} >
                                                            <EmailIcon className="pointer" />
                                                        </div>
                                                    </a>
                                                    <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <WhatsappFilled className="pointer figma-icon" />
                                                        </div>
                                                    </a>
                                                    <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <GroupChatFilled className="pointer figma-icon" />
                                                        </div>
                                                    </a>
                                                    <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <ForumIcon className="pointer" />
                                                        </div>
                                                    </a>

                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VolumeUpRoundedIcon className="pointer" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VideoTutorialFilled className="pointer figma-icon" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <AttachFileIcon className="pointer figma-icon" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VideoCallFilled className="pointer figma-icon" />
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    </div>
                                );
                            })}



                        </ul>
                    </div>
                )}
            </div>

            {selectedContacts?.length > 0 && (
                <div className={`action-bar ${Object.keys(selectedItems)?.length > 0 ? 'open' : ''}`}>
                    {cceFunctions.map((item, index) => {
                        const SvgIcon = item.icon; // Get the component reference
                        return (
                            <a href={item.href} target="_blank" rel="noreferrer" key={index}>
                                <IconButton className="white-icon-hover me-4" onClick={item.function} key={index}>
                                    <SvgIcon className='white-svg svg-icon-32px' />
                                </IconButton>
                            </a>
                        )
                    })}
                </div>
            )}

            <SpeedDialComponent />

            {/* <LayoutBox deleteConfirm={deleteConfirm} setdeleteConfirm={setdeleteConfirm} handleDeleteCard={handleDelete}
                muteContact={muteContact} setMuteContact={setMuteContact} handleSaveMute={handleSaveMute} /> */}
        </div>
    );
}


export default CardConnectedMembers;
